import lookupState from "./lookupOldState";

// RP self-hosted: prefer the API-served catalog (so admins can add/edit
// modules without a redeploy). Fall back to the static California.json
// asset if the API is unreachable — the bundle still ships with a frozen
// snapshot for graceful degradation.
function fetchFromApi(stateName) {
    return fetch("/api/modules?state=" + encodeURIComponent(stateName))
        .then(resp => {
            if (!resp.ok) throw new Error("API " + resp.status);
            return resp.json();
        })
        .then(d => Array.isArray(d.modules) ? d.modules : []);
}

function fetchFromStatic(stateName) {
    return fetch("/assets/data/modules/" + stateName + ".json").then(resp => resp.json());
}

function fetchAndMerge(stateName) {
    // Try API first. If it returns at least one module, use it. Otherwise
    // fall back to the static file. (We don't merge — the API is intended
    // to be authoritative once seeded.)
    return fetchFromApi(stateName)
        .then(modules => modules.length > 0 ? modules : fetchFromStatic(stateName))
        .catch(() => fetchFromStatic(stateName));
}

export function listPlaces(placeID, stateName) {
    if (!stateName) {
        stateName = lookupState[placeID];
    }
    if (placeID) {
        return fetchAndMerge(stateName).then(data => data.filter(d => d.id === placeID));
    } else {
        return fetchAndMerge(stateName);
    }
}
